import { SINK_OPTIONS, SortBy } from '@common/enums';
import { ApplianceModel, Filter } from '@common/models';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type SinkFilters = Record<string, Filter>;

interface SinkState {
    selectedSink?: ApplianceModel;
    sortBy: SortBy;
    inStoreSinksUrl?: string;
    sinkSelectedOption?: SINK_OPTIONS;
    sinkFilters?: SinkFilters;
}

const initialState: SinkState = {
    selectedSink: undefined,
    sinkFilters: undefined,
    sortBy: SortBy.None,
    inStoreSinksUrl: undefined,
};

const sinkSlice = createSlice({
    name: 'sink',
    initialState,
    reducers: {
        resetSinkSelectedOption: (state) => {
            state.sinkSelectedOption = initialState.sinkSelectedOption;
        },
        resetSelectedSink: (state) => {
            state.selectedSink = initialState.selectedSink;
        },
        updateSelectedSink: (state, action: PayloadAction<ApplianceModel | undefined>) => {
            state.selectedSink = action.payload;
        },
        updateSinkSelectedOption: (state, action: PayloadAction<SINK_OPTIONS | undefined>) => {
            state.sinkSelectedOption = action.payload;
        },
        updateSinkFilters: (state, action: PayloadAction<SinkFilters>) => {
            state.sinkFilters = action.payload;
        },
        resetSinks: (state) => {
            state.sinkFilters = initialState.sinkFilters;
            state.sinkSelectedOption = initialState.sinkSelectedOption;
        },
        resetSinkFilters: (state) => {
            state.sinkFilters = undefined;
        },
        setSinkSortBy: (state, action: PayloadAction<SortBy>) => {
            state.sortBy = action.payload;
        },
        updateInStoreSinksUrl: (state, action: PayloadAction<string | undefined>) => {
            state.inStoreSinksUrl = action.payload;
        },
    },
});

export const {
    resetSinkSelectedOption,
    resetSelectedSink,
    updateSinkSelectedOption,
    updateSelectedSink,
    resetSinks,
    resetSinkFilters,
    setSinkSortBy,
    updateInStoreSinksUrl,
    updateSinkFilters,
} = sinkSlice.actions;

export default sinkSlice.reducer;

export const selectSinkSelectedOption = ({ sink }: RootState): SINK_OPTIONS | undefined => sink.sinkSelectedOption;

export const selectSelectedSink = ({ sink }: RootState): ApplianceModel | undefined => sink.selectedSink;

export const selectSinkSortBy = ({ sink }: RootState): SortBy => sink.sortBy;

export const selectSinkFilters = ({ sink }: RootState): SinkFilters | undefined => sink.sinkFilters;

export const selectInStoreSinksUrl = ({ sink }: RootState): string | undefined => sink.inStoreSinksUrl;
